import { render } from "./ProgressBarLive.vue?vue&type=template&id=dc4d285e"
import script from "./ProgressBarLive.vue?vue&type=script&lang=js"
export * from "./ProgressBarLive.vue?vue&type=script&lang=js"
script.render = render

export default script